import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { EmptyState, ErrorState, LoadingState, StatusBadge } from "@/components/app/AppUI";
import { eventRepository } from "@/data/repositories";

export const Route = createFileRoute("/portal/")({ component: PortalHome });
function PortalHome() {
  const query = useQuery({
    queryKey: ["portal-events"],
    queryFn: () => eventRepository.portalEvents(),
  });
  if (query.isLoading) return <LoadingState label="Abriendo tu portal" />;
  if (query.error) return <ErrorState message={query.error.message} />;
  return (
    <div className="space-y-8">
      <header className="max-w-3xl">
        <p className="eyebrow text-primary">Bienvenidos al backstage</p>
        <h1 className="mt-4 font-display text-5xl leading-[0.9] md:text-7xl">
          VUESTRO EVENTO, CANCIÓN A CANCIÓN.
        </h1>
        <p className="mt-5 text-xl text-muted-foreground">
          Completad la planificación a vuestro ritmo. Cada cambio queda guardado para ambas cuentas.
        </p>
      </header>
      <section className="grid gap-5 md:grid-cols-2">
        {(query.data ?? []).length === 0 ? (
          <div className="md:col-span-2">
            <EmptyState
              title="No hay eventos vinculados"
              description="Comprueba que estás usando el email al que llegó la invitación."
            />
          </div>
        ) : (
          query.data?.map((event) => (
            <Link
              key={event.id}
              to="/portal/eventos/$id"
              params={{ id: event.id }}
              className="group panel relative overflow-hidden p-6 transition-transform hover:-translate-y-1"
            >
              <div className="absolute right-0 top-0 h-full w-2 bg-primary" />
              <CalendarDays className="size-6 text-primary" />
              <h2 className="mt-8 font-display text-3xl">{event.title}</h2>
              <p className="mt-3 text-muted-foreground">
                {event.starts_at
                  ? new Intl.DateTimeFormat("es-ES", { dateStyle: "long" }).format(
                      new Date(event.starts_at),
                    )
                  : "Fecha pendiente"}{" "}
                · {event.venue ?? "Lugar pendiente"}
              </p>
              <div className="mt-8 flex items-center justify-between">
                <StatusBadge status={event.status} />
                <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-primary">
                  Abrir <ArrowUpRight className="size-4" />
                </span>
              </div>
            </Link>
          ))
        )}
      </section>
    </div>
  );
}
